import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { serviceItemSagaActions } from "../../Information/ServiceItem";

import { ServiceItemsCatalogueCarousel } from "../components/ServiceItemsCatalogueCarousel";
import { useSubheader } from "../../../../_metronic/layout";
import { DepartmentHeader } from "../components/DepartmentHeader";

import { Form, Col, Card, Container, Row, Spinner, Button } from "react-bootstrap";
import { Search, ArrowBarLeft } from "react-bootstrap-icons";

//import "../css/bootstrap-card-columns.css";
// import styles from "../css/payment.module.css";
//import cardColStyles from "../css/CardColumn.module.css";


export const ServiceItemsCatalogue = (props) => {
  const subheader = useSubheader();

  const dispatch = useDispatch();
  const history = useHistory();

  const { 
    servItem : { entities: serviceItems, totalCount: serviceItemsTotalCount, listLoading },
    catalogue: { selectedDept, selectedService, selectedProvince } 
  } = useSelector((state) => state);

  const deptId = selectedDept.id;
  const serviceId = selectedService.id;
  const servName = selectedService.name;
  const deptName = selectedService.dept_name;
  const provName = selectedService.prov_name;
  const provId = selectedProvince.id;

  subheader.setTitle(deptName);

  useEffect(() => {
    if( deptId === undefined || deptId === null ){
      history.push("/catalogue-management/departments");
    }
  }, [ history, deptId ]);

  const handleBackNavigation = () => {
    history.push({pathname:"/catalogue-management/services", state:{deptId}});
  };

  const debounceFunction = (func, delay) => {
    
    let timer;

    return function() {
      let self = this;
      let args= arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(self, args)
      }, delay)
    }
  };

  //use useCallback to memoized or remeber the original function
  const debounceCatalogueSearch = useCallback(
    debounceFunction(
      (nextValue) => {
        let query = nextValue;
        dispatch(serviceItemSagaActions.searchServItemsUnderService(query, serviceId, deptId, provId));

      }, 500
  ),[]);

  const handleCatalogueSearch = (event) =>{
    let nextValue = event.target.value;
    debounceCatalogueSearch(nextValue);
  };
  
  return (
    <Card>    
      <Card.Header>
        <Row>
          <Col lg={7} md={12} sm={12}>
            <DepartmentHeader deptName={deptName} provName={provName} listName={`${servName} Service Items`} deptLogo={selectedDept.logo_image} />
          </Col>
          <Col lg={5} md={12} sm={12}>
            <Button onClick={handleBackNavigation} style={{float:"right"}} variant="secondary">
              <ArrowBarLeft size={18} /> {" "} BACK
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Container fluid>
          <Row>
            <Col>
              <Form.Group controlId="search">
                <Search size={30} className="pt-3 pl-3" style={{ position: "absolute" }}/>
                <Form.Control
                  className="pl-10"
                  style={{ fontSize: "16px"}}
                  name="search"
                  placeholder="Search for a service item"
                  onChange={handleCatalogueSearch}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              { listLoading
                ? <Spinner className="listSpinner" animation="border" />
                : ( serviceItemsTotalCount <= 0 ? <h5 className="d-flex justify-content-center">No Service Items Found</h5> 
                  : <ServiceItemsCatalogueCarousel serviceItems={serviceItems} serviceItemsTotalCount={serviceItemsTotalCount} deptId={deptId} selectedProv={selectedProvince} /> )
              }
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};